import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export interface FollowPayload {
  followingId: string;
  followingType?: 'CREATOR' | 'USER';
}

export const followsService = {
  async follow(payload: FollowPayload) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/follows`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string; follow: any };
  },

  async unfollow(followingId: string, followingType: 'CREATOR' | 'USER' = 'CREATOR') {
    const token = localStorage.getItem('accessToken');
    const res = await axios.delete(`${API_BASE_URL}/api/follows/${followingId}`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { type: followingType },
    });
    return res.data as { message: string };
  },

  async getFollowers(followingId: string, followingType: 'CREATOR' | 'USER' = 'CREATOR', params?: { limit?: number; offset?: number }) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/follows/${followingId}/followers`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      params: { type: followingType, limit: 50, offset: 0, ...params },
    });
    return res.data as {
      followers: Array<{
        id: string;
        username: string;
        firstName?: string;
        lastName?: string;
        avatar?: string;
        bio?: string;
      }>;
      pagination: { total: number; limit: number; offset: number; hasMore: boolean };
    };
  },

  async getFollowing(params?: { limit?: number; offset?: number; type?: 'CREATOR' | 'USER' }) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/follows/me/following`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { limit: 50, offset: 0, ...params },
    });
    return res.data as {
      following: {
        creators: any[];
        users: any[];
      };
      pagination: { total: number; limit: number; offset: number; hasMore: boolean };
    };
  },

  async checkStatus(followingId: string, followingType: 'CREATOR' | 'USER' = 'CREATOR') {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/follows/${followingId}/status`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { type: followingType },
    });
    return res.data as { isFollowing: boolean };
  },
};


